var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "related-business",
      style: { "margin-left": _vm.marginLeft },
    },
    [
      _vm.showAdd
        ? _c(
            "el-popover",
            {
              attrs: {
                placement: "right-end",
                width: "800",
                "popper-class": "no-padding-popover",
                trigger: "click",
              },
              model: {
                value: _vm.showPopover,
                callback: function ($$v) {
                  _vm.showPopover = $$v
                },
                expression: "showPopover",
              },
            },
            [
              _vm.showRelative
                ? _c("crm-relative", {
                    ref: "crmrelative",
                    attrs: {
                      show: _vm.showPopover,
                      radio: false,
                      "selected-data": _vm.relatedListData,
                      "show-types": _vm.showTypes,
                    },
                    on: {
                      close: _vm.crmrelativeClose,
                      changeCheckout: _vm.checkInfos,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showCRMPermission
                ? _c(
                    "span",
                    {
                      staticClass: "add-btn",
                      attrs: { slot: "reference" },
                      on: {
                        click: function ($event) {
                          _vm.showRelative = true
                        },
                      },
                      slot: "reference",
                    },
                    [
                      _c("i", { staticClass: "wk wk-l-plus" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "label" }, [
                        _vm._v("关联业务"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.relatedListData, function (items, key) {
        return _c(
          "div",
          { key: key, staticStyle: { "margin-top": "10px" } },
          _vm._l(items, function (item, itemIndex) {
            return _c("related-business-cell", {
              key: itemIndex,
              attrs: {
                data: item,
                "cell-index": itemIndex,
                type: key,
                "show-foot": _vm.showFoot,
              },
              on: {
                unbind: _vm.delRelevance,
                detail: function ($event) {
                  return _vm.checkRelatedDetail(key, item)
                },
              },
            })
          }),
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }